import Button from '@anm/components/buttons/Button';
import styled, { css } from 'styled-components';

import { FieldWithButtonDirection } from '.';

type FieldWithButtonWrapperProps = {
  hasError: boolean;
  direction: FieldWithButtonDirection;
};
const directions: {
  [key in FieldWithButtonDirection]: ReturnType<typeof css>;
} = {
  horizontal: css``,
  vertical: css`
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  `
};

const FieldWithButtonWrapper = styled.div<FieldWithButtonWrapperProps>`
  display: flex;
  max-width: 100%;
  ${({ direction }) => directions[direction]}

  &>div {
    width: 100%;
    overflow: hidden;

    a {
      display: block;
    }
  }

  input {
    ${({ hasError }) =>
      hasError &&
      css`
        border: 1px solid var(--error) !important;
        border-right: none !important;
      `}
  }

  span {
    display: inline-block;
    margin-top: 2px;
    color: var(--error);
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
  }
`;

export const ButtonWrapper = styled(Button)`
  min-width: 130px;
  padding: 0 10px;
`;

export default FieldWithButtonWrapper;
